import NoTicketToShow from "./NoTicketToShow";
import styles from "./Tickets.module.scss";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userTickets } from "../../../actions/user";
import { isEmpty } from "lodash";
import { convertToPersian } from "../../../utils/convertMoment";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
//No Ticket For When User Haven't any Messages
function Tickets() {
  const dispatch = useDispatch();
  const tickets = useSelector((state) => state.fullUserInfo.data_tickets);
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  useEffect(() => {
    dispatch(userTickets());
  }, []);
  return (
    <>
      {loadingBar && <LoadingPage />}
      <section className={styles.container}>
        {isEmpty(tickets) ? (
          <NoTicketToShow />
        ) : (
          <div className={styles.user_tickets_container}>
            <div className={`font_color_white ${styles.header_title}`}>
              تیکت ها
            </div>
            <div className={styles.messages_container}>
              <ul>
                {tickets.map((ticket) => (
                  <li className={styles.message_container} key={ticket.id}>
                    <div className={styles.ticket_title_and_desc}>
                      <div
                        className={` changeTextColorToGreen ${styles.ticket_number}`}
                      >
                        {ticket.id}
                      </div>
                      <div
                        className={`font_color_white ${styles.ticket_title}`}
                      >
                        شماره:{" "}
                      </div>
                    </div>
                    <div className={styles.ticket_title_and_desc}>
                      <div
                        className={`changeTextColorToGreen ${styles.ticket_subject}`}
                      >
                        {ticket.title}
                      </div>
                      <div
                        className={`font_color_white ${styles.ticket_title}`}
                      >
                        عنوان:{" "}
                      </div>
                    </div>
                    <div className={styles.ticket_title_and_desc}>
                      <div
                        className={`changeTextColorToGreen ${styles.ticket_department}`}
                      >
                        {ticket.department === "SALES"
                          ? "مالی (برداشت و واریز)"
                          : ticket.department === "TECH"
                          ? "پشتیبانی فنی"
                          : "پشتبانی عمومی"}
                      </div>
                      <div
                        className={`font_color_white ${styles.ticket_title}`}
                      >
                        دپارتمان:{" "}
                      </div>
                    </div>
                    <div className={styles.ticket_title_and_desc}>
                      <div
                        className={`changeTextColorToGreen ${styles.ticket_date}`}
                      >
                        {convertToPersian(ticket.date)}
                      </div>
                      <div
                        className={`font_color_white ${styles.ticket_title}`}
                      >
                        تاریخ:{" "}
                      </div>
                    </div>
                    <div
                      className={`${styles.ticket_title_and_desc} ${styles.status_bg}`}
                    >
                      <div
                        className={`changeTextColorToGreen ${styles.ticket_status}`}
                      >
                        {ticket?.status === "UNCHECKED"
                          ? "بررسی نشده"
                          : ticket?.status === "WAITING"
                          ? "در حال بررسی"
                          : ticket?.status === "ANSWERED"
                          ? "پاسخ داده شده"
                          : ticket?.status === "USER_ANSWERED"
                          ? "پاسخ کاربر"
                          : "بسته شده"}
                      </div>
                      <div
                        className={` font_color_white ${styles.ticket_title}`}
                      >
                        وضعیت:{" "}
                      </div>
                    </div>
                    <div className={styles.text_of_ticket}>
                      <Link to={`/my-tickets/${ticket.id}`}>
                        <div>متن تیکت</div>
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.button_footer}>
              <Link to="/record-ticket">
                <button className={styles.recordTicket_button}>ثبت تیکت</button>
              </Link>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
export default Tickets;
